app.controller(
    'AdminUserListController', ['$scope', '$rootScope', '$http', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'UserService', 'AdminService', '$sce', '$translate', AdminUserListController]
);

function AdminUserListController($scope, $rootScope, $http, $stateParams, $timeout, toastr, $document, Configuration, UserService, AdminService, $sce, $translate) {
    
    $translate.use($rootScope.LangForInterface);


    var vm = this;
    vm.modalObject = {};
    vm.UserList = []; //declare an empty array
    vm.pageno = 1; // initialize page no to 1
    vm.total_count = 0;
    vm.sortKey = "FirstName";
    vm.direction = "ascending";
    vm.reverse = false,
    vm.itemsPerPage = 10; //this could be a dynamic value from a drop down
    vm.getData = function (pageno, sortKey, reverse) { // This would fetch the data on page change.
        //In practice this should be in a factory.
        vm.UserList = [];
        //Get List 
        var promiseGetList = UserService.GetUserList(vm.itemsPerPage, pageno, sortKey, reverse, $rootScope.LangForWork);
        promiseGetList.then(function (response) {
            vm.UserList = response.data.UserList;  // data to be displayed on current page.
            vm.total_count = response.data.total_count; // total data count.
        });
    };
    vm.getData(vm.pageno, vm.sortKey, vm.reverse); // Call the function to fetch initial data on page load.

    if ($rootScope.RedirectFromUserCreation == true) {
        toastr.success($translate.instant("NousVousConfirmonsQueVotreActionEstBienEnregistree"));
        $rootScope.RedirectFromUserCreation = false;
    }

    $scope.vm = vm;        

    $scope.sort = function (keyname) {
        vm.sortKey = keyname;   //set the sortKey to the param passed
        vm.reverse = !vm.reverse; //if true make it false and vice versa
        vm.getData(vm.pageno, keyname, vm.reverse);
    }

    vm.getUserUrl = function (userId) {
        var urlDynamique = '/#!/admin/user/info?id=';

        return $rootScope.interfaceSubFolder + urlDynamique + userId;
    }

    vm.DeleteUser = function (user) {
        AdminService.DeleteUser(user)
       .then(
               function success(data) {
                   location.reload();
               },
               function error(data) { });


    }

    vm.ShowDeleteConfirmation = function (user) {
        vm.modalObject.user = user;
        $scope.modalDelete = true;
    };

    vm.DeleteUserFromConfirmation = function () {
        vm.DeleteUser(vm.modalObject.user);
        $scope.modalDelete = false;
    };
};